import { useEffect } from "react";
import { motion } from "framer-motion";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import ProblemSection from "../components/ProblemSection";
import FeaturesSection from "../components/FeaturesSection";
import WhyUsSection from "../components/WhyUsSection";
import TestimonialsSection from "../components/TestimonialsSection";
import ROISection from "../components/ROISection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

const LandingPage = () => {
  useEffect(() => {
    document.title = "InwardSync Automations | Stop the WhatsApp Chaos";
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-cream"
      data-testid="landing-page"
    >
      <Navbar />
      <main>
        <HeroSection />
        <ProblemSection />
        <FeaturesSection />
        <WhyUsSection />
        <TestimonialsSection />
        <ROISection />
        <ContactSection />
      </main>
      <Footer />
    </motion.div>
  );
};

export default LandingPage;
